import gql from "graphql-tag";

const projectContactMutations = {


    createProjectContact: gql`
        mutation CreateProjectContact($project_id: Int, $contact_id: Int, $notes: String, $description: String) {
            createProjectContact(project_id: $project_id, contact_id: $contact_id, notes: $notes, description: $description) {
                id,
                project_id,
                contact_id,
                notes,
                description
            }
        }
    `,
    updateProjectContact: gql`
        mutation UpdateProjectContact($id: ID!, $project_id: Int, $contact_id: Int, $notes: String, $description: String) {
            updateProjectContact(id: $id, project_id: $project_id, contact_id: $contact_id, notes: $notes, description: $description) {
                id,
                project_id,
                contact_id,
                notes,
                description
            }
        }
    `,
};

export default projectContactMutations;